import { render, staticRenderFns } from "./DetailsFeeInput.vue?vue&type=template&id=bb1daf4c&scoped=true"
import script from "./DetailsFeeInput.vue?vue&type=script&lang=js"
export * from "./DetailsFeeInput.vue?vue&type=script&lang=js"
import style0 from "./DetailsFeeInput.vue?vue&type=style&index=0&id=bb1daf4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1daf4c",
  null
  
)

export default component.exports